import React from 'react';
import { useTranslation } from 'react-i18next';
import PopUp from '../../shared/PopUp/PopUp';
import { IconPro } from '../Icons/IconPro';
import './modals.css';
import IconHelp from '../Icons/IconHelp';
import { useAuth } from '../../context/AuthContext';

const ModalCalculadora = ({ isOpen, onClose, onOpenPacks, onShowLogin }) => {
	const { t } = useTranslation();
	const { state } = useAuth();

	const handleViewPacks = () => {
		onClose();
		if (!state?.isAuthenticated) {
			onShowLogin();
		} else {
			onOpenPacks();
		}
	};

	return (
		<PopUp
			isOpen={isOpen}
			onClose={onClose}
			classes="modal-calculadora">
			<div className="modal-calculadora__header">
				<h3 className="modal-calculadora__title">
					<span>{t('section_plataforma.modal_calculadora.title')}</span>
					<span className="modal-calculadora__title-icon">
						<IconPro fill="#1A2228" />
					</span>
				</h3>
				<p className="modal-calculadora__message">{t('section_plataforma.modal_calculadora.message')}</p>
			</div>

			<div className="modal-calculadora__body">
				<div className="modal-calculadora__plans">
					<div className="modal-calculadora__plans-left">
						<div className="modal-calculadora__plans-left-header">
							<h3 className="modal-calculadora__plans-left-title">
								{t('section_plataforma.modal_calculadora.title_pro')}
							</h3>
							<p className="modal-calculadora__plans-left-subtitle">
								{t('section_plataforma.modal_calculadora.subtitle_pro')}
							</p>
						</div>

						<div className="modal-calculadora__plans-left-content">
							{/* Plan Basic */}
							<div className="modal-calculadora__plans-item">
								<span className="modal-calculadora__plans-item-label">
									{t('section_plataforma.modal_calculadora.plan_basic.label')}
								</span>
								<div className="modal-calculadora__plans-item-price">
									<span className="modal-calculadora__plans-item-price-label">
										{t('section_plataforma.modal_calculadora.plan_basic.price')}
									</span>
									<span className="modal-calculadora__plans-item-price-text">
										{t('section_plataforma.modal_calculadora.plan_basic.price_text')}
									</span>
								</div>
								<ul className="modal-calculadora__plans-item-list">
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_basic.list.item1')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_basic.list.item2')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_basic.list.item3')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_basic.list.item4')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_basic.list.item5')}
									</li>
								</ul>
								<a
									href={t('section_plataforma.modal_calculadora.plan_basic.link.href')}
									className="modal-calculadora__plans-item-link"
									title={t('section_plataforma.modal_calculadora.plan_basic.link.title')}>
									{t('section_plataforma.modal_calculadora.plan_basic.link.title')}
								</a>
							</div>

							{/* Plan Pro */}
							<div className="modal-calculadora__plans-item modal-calculadora__plans-item--pro">
								<span className="modal-calculadora__plans-item-label">
									<IconPro fill="white" />
									{t('section_plataforma.modal_calculadora.plan_pro.label')}
								</span>
								<div className="modal-calculadora__plans-item-price">
									<span className="modal-calculadora__plans-item-price-label">
										{t('section_plataforma.modal_calculadora.plan_pro.price')}
									</span>
									<span className="modal-calculadora__plans-item-price-text">
										{t('section_plataforma.modal_calculadora.plan_pro.price_text')}
									</span>
								</div>
								<ul className="modal-calculadora__plans-item-list">
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_pro.list.item1')}
										<span className="modal-calculadora__plans-item-list-item-icon">
											<IconHelp />
										</span>
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_pro.list.item2')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_pro.list.item3')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_pro.list.item4')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_pro.list.item5')}
									</li>
								</ul>
								<button
									type="button"
									className="modal-calculadora__plans-item-link"
									onClick={handleViewPacks}
									aria-label={t('section_plataforma.modal_calculadora.plan_pro.link.title')}>
									{t('section_plataforma.modal_calculadora.plan_pro.link.title')}
								</button>
							</div>
						</div>
					</div>

					{/* Consultancy */}
					<div className="modal-calculadora__plans-right">
						<div className="modal-calculadora__plans-right-header">
							<h3 className="modal-calculadora__plans-right-title">
								{t('section_plataforma.modal_calculadora.title_consultancy')}
							</h3>
						</div>
						<div className="modal-calculadora__plans-right-content">
							<div className="modal-calculadora__plans-item modal-calculadora__plans-item--consultancy">
								<div className="modal-calculadora__plans-item-price">
									<span className="modal-calculadora__plans-item-price-label">
										{t('section_plataforma.modal_calculadora.plan_consultancy.price')}
									</span>
									<span className="modal-calculadora__plans-item-price-text">
										{t('section_plataforma.modal_calculadora.plan_consultancy.price_text')}
									</span>
								</div>
								<ul className="modal-calculadora__plans-item-list">
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_consultancy.list.item1')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_consultancy.list.item2')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_consultancy.list.item3')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_consultancy.list.item4')}
									</li>
									<li className="modal-calculadora__plans-item-list-item">
										{t('section_plataforma.modal_calculadora.plan_consultancy.list.item5')}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className="modal-calculadora__footer"
				dangerouslySetInnerHTML={{
					__html: t('section_plataforma.modal_calculadora.footer.text'),
				}}
			/>
		</PopUp>
	);
};

export default ModalCalculadora;
